var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 103,
    viewBox: "0 0 124 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 9.71124V41.0528M119.5 41.0528H88.1364M119.5 41.0528L95.2455 18.2779C89.6275 12.6611 82.6771 8.5579 75.043 6.35128C67.4089 4.14467 59.3399 3.90652 51.5888 5.65908C43.8377 7.41163 36.6571 11.0978 30.7172 16.3735C24.7773 21.6493 20.2716 28.3427 17.6205 35.8292M4.5 93.2888V61.9472M4.5 61.9472H35.8636M4.5 61.9472L28.7545 84.7221C34.3725 90.3389 41.3229 94.4421 48.957 96.6487C56.5911 98.8553 64.6601 99.0935 72.4112 97.3409C80.1623 95.5884 87.3429 91.9022 93.2828 86.6265C99.2227 81.3507 103.728 74.6573 106.38 67.1708",
    stroke: "#4B423A",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.189a0c7d2f299f5d6bd0dbb4cbf302a6.svg";
export { ForwardRef as ReactComponent };